var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.49 27L56.62 21.98C55.95 21.54 55.05 21.54 54.37 21.98L46.5 27.22C46.28 27.44 46.05 27.66 46.05 28.09V36.17C46.05 36.61 46.2701 36.83 46.7201 36.83C47.1701 36.83 47.39 36.61 47.39 36.17V29.62L54.14 34.21C54.14 34.21 54.3601 34.43 54.59 34.43V42.73L50.7701 40.11C50.5501 39.89 49.8701 39.89 49.6501 40.33C49.4301 40.77 49.43 41.2 49.87 41.42L54.82 44.7L55.0401 44.92L55.26 45.14C55.48 45.14 55.48 45.14 55.71 45.14L64.25 39.68C64.47 39.46 64.7001 39.24 64.4701 39.02V28.75C64.9401 27.44 64.94 27.22 64.49 27ZM56.62 33.77L63.37 29.18V37.92L56.17 42.51V33.99C56.39 33.99 56.62 33.99 56.62 33.77Z",
    fill: "url(#paint0_linear_239_270)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0101 15.64C24.4601 15.64 24.6801 15.2 24.6801 14.98V8.43001L31.6501 12.8C31.6501 12.8 31.8701 12.8 31.8701 13.02V21.98L27.3701 18.92C27.1501 18.7 26.4701 18.7 26.2501 19.14C26.0301 19.58 26.0301 20.01 26.4701 20.23L31.8701 23.73C32.0901 23.95 32.3201 24.17 32.5401 24.17C32.5401 24.17 32.5401 24.17 32.7601 24.17C32.9801 24.17 32.9801 23.95 33.2101 23.95L38.3801 20.45C38.6001 20.23 38.6001 19.79 38.3801 19.36C38.1601 18.93 37.7101 18.92 37.2601 19.14L33.2101 21.76V13.02C33.4301 13.02 33.4301 12.8 33.6601 12.8L40.6301 8.21001V14.76C40.6301 15.2 40.8501 15.42 41.3001 15.42C41.7501 15.42 41.9701 14.98 41.9701 14.76V6.90001C41.9701 6.46001 41.9701 6.24001 41.5201 6.03001L33.9101 1.00001C33.2401 0.560013 32.3401 0.560013 31.6601 1.00001L23.7901 6.24001C23.5701 6.46001 23.3401 6.68001 23.3401 7.11001V15.19C23.3401 15.2 23.5601 15.64 24.0101 15.64Z",
    fill: "url(#paint1_linear_239_270)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2301 58.46V48.41C42.2301 48.19 42.2301 47.75 41.7801 47.54L33.9101 42.52C33.2401 42.08 32.3401 42.08 31.6601 42.52L23.7901 47.76C23.5701 47.98 23.3401 48.2 23.3401 48.63V59.12C23.3401 59.12 23.3401 59.12 23.3401 59.34C23.3401 59.56 23.3401 59.78 23.5601 59.78L32.1001 65.24C32.3201 65.24 32.5501 65.46 32.7701 65.24C32.9901 65.24 33.2201 65.02 33.4401 64.8L41.7601 59.56C41.9801 59.56 42.2101 59.34 42.2101 58.9C42.2101 58.9 42.2101 58.9 42.2101 58.68L42.2301 58.46C42.2301 58.67 42.2301 58.67 42.2301 58.46ZM33.9101 54.31L40.8801 49.72V58.24L33.4601 62.83V54.53C33.6801 54.52 33.6801 54.52 33.9101 54.31ZM31.8801 54.52V63.26L24.6801 58.67V50.15L31.6501 54.52C31.6601 54.31 31.8801 54.52 31.8801 54.52Z",
    fill: "url(#paint2_linear_239_270)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 39.89L10.52 42.51V33.99C10.74 33.99 10.74 33.77 10.97 33.77L17.94 29.18V35.73C17.94 36.17 18.39 36.39 18.61 36.39C19.06 36.39 19.28 36.17 19.28 35.73V27.65C19.28 27.43 19.06 26.99 18.83 26.78L10.73 21.97C10.06 21.53 9.16003 21.53 8.48003 21.97L0.610034 27.21C0.390034 27.21 0.160034 27.43 0.160034 27.87V38.36C0.160034 38.8 0.380034 39.02 0.830034 39.02L9.15003 44.48H9.37003C9.59003 44.48 9.59003 44.48 9.82003 44.48C10.04 44.48 10.27 44.26 10.27 44.04L15.22 40.76C15.67 40.54 15.67 40.1 15.44 39.67C15.24 39.23 14.79 39.67 14.34 39.89ZM8.95003 33.99V42.51L1.75003 37.7V29.18L8.50003 33.77C8.72003 33.99 8.72003 33.99 8.95003 33.99Z",
    fill: "url(#paint3_linear_239_270)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 23.29L28.28 15.86C28.73 15.64 28.73 14.99 28.5 14.77C28.28 14.55 27.6 14.33 27.15 14.55L16.58 21.98C16.13 22.2 16.13 22.85 16.36 23.07C16.82 23.5 17.27 23.5 17.71 23.29Z",
    fill: "url(#paint4_linear_239_270)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.43 44.04L51 36.61C51.45 36.39 51.45 35.74 51.22 35.52C51 35.08 50.32 35.08 50.1 35.3L39.53 42.73C39.08 42.95 39.08 43.6 39.31 43.82C39.53 44.04 40.2 44.26 40.43 44.04Z",
    fill: "url(#paint5_linear_239_270)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1201 35.52C13.9001 35.96 13.9001 36.39 14.3401 36.61L24.9101 44.04C25.3601 44.26 25.8101 44.26 26.0301 43.82C26.2501 43.38 26.2501 42.95 25.8101 42.73L15.2401 35.3C14.7901 35.08 14.3401 35.08 14.1201 35.52Z",
    fill: "url(#paint6_linear_239_270)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.05 14.77C36.83 15.21 36.83 15.64 37.27 15.86L47.84 23.29C48.29 23.51 48.74 23.51 48.96 23.07C49.18 22.63 49.18 22.2 48.74 21.98L38.17 14.55C37.73 14.33 37.28 14.33 37.05 14.77Z",
    fill: "url(#paint7_linear_239_270)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_270",
    x1: 46.0482,
    y1: 33.3883,
    x2: 65.0461,
    y2: 33.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_270",
    x1: 23.3143,
    y1: 12.417,
    x2: 42.2931,
    y2: 12.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_270",
    x1: 23.3368,
    y1: 53.7528,
    x2: 42.3155,
    y2: 53.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_270",
    x1: 0.175434,
    y1: 33.0606,
    x2: 19.1541,
    y2: 33.0606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_239_270",
    x1: 29.5738,
    y1: 13.5206,
    x2: 103.86,
    y2: -42.6409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_239_270",
    x1: 48.1913,
    y1: 37.4537,
    x2: 122.457,
    y2: -18.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_239_270",
    x1: 39.4603,
    y1: 25.0142,
    x2: 116.054,
    y2: -32.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_239_270",
    x1: 37.0042,
    y1: 23.4584,
    x2: 113.598,
    y2: -34.4478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices2);
export default __webpack_public_path__ + "static/media/services2.0bec17401f296a85be124732635fedca.svg";
export { ForwardRef as ReactComponent };